module.exports = __webpack_public_path__ + "media/images/store_badges/app_store/app_store-60abf8a642d2bec0f150f94feeba456f.png";